import { lazy } from 'react'
import { SuspenseLoader } from 'v2/shared/components/suspense-loader'

/**
 * Simple lazy component creator that returns the lazy component directly
 * Suspense boundary should be handled at the route level
 */
export const createLazyComponent = (importFn: () => Promise<{ default: React.ComponentType }>) => {
  return lazy(importFn)
}

/**
 * Generic loading fallback for all lazy components
 */
export const LoadingFallback = () => <SuspenseLoader text="Loading..." />

/**
 * Preload a lazy component (useful for prefetching on hover/focus)
 */
export const preloadComponent = (importFn: () => Promise<unknown>) => {
  return importFn()
}
